class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (window.updateFreeShippingBar) {
      requestAnimationFrame(() => window.updateFreeShippingBar());
    }

    var checkboxes = document.querySelectorAll('.terms-container input[type="checkbox"]');
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', handleCheckboxChange);
    });

    if (checkboxes.length > 0) {
    handleCheckboxChange({ target: checkboxes[0] });
  }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Make a global helper that the discount script can call
window.refreshCartDrawerAfterDiscount = async function (cart) {
  try {
    // 1) Fetch updated sections HTML for the drawer + cart icon
    const sectionsRes = await fetch(
      window.Shopify.routes.root + 'cart?sections=cart-drawer,cart-icon-bubble'
    );

    if (!sectionsRes.ok) {
      throw new Error('Sections fetch failed: ' + sectionsRes.status + ' ' + sectionsRes.statusText);
    }

    const sections = await sectionsRes.json();

    // 2) Build a "parsedState"-like object that renderContents expects
    const parsedState = Object.assign({}, cart, {
      sections: sections,
    });

    // 3) Ask the cart drawer element to re-render itself
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(parsedState);
    }
  } catch (err) {
    console.error('Failed to refresh cart drawer after discount', err);
  }
};


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/**
 * Sandon JS
 */

// Function to check if the checkbox is checked
function isCheckboxChecked() {
  var checkbox = document.getElementById('agree');
  return checkbox.checked;
}

// Function to disable checkout buttons
function disableCheckoutButtons() {
  var checkoutButtons = document.querySelectorAll('.cart__checkout-button');
  checkoutButtons.forEach(function (button) {
    button.disabled = true;
  });
}

// Function to enable checkout buttons
function enableCheckoutButtons() {
  var checkoutButtons = document.querySelectorAll('.cart__checkout-button');
  checkoutButtons.forEach(function (button) {
    button.disabled = false;
  });
}

// Function to disable buttons within dynamic-checkout__content
function disableDynamicCheckoutButtons() {
  var dynamicCheckoutButtons = document.querySelectorAll('.dynamic-checkout__content button');
  dynamicCheckoutButtons.forEach(function (button) {
    button.disabled = true;
    button.style.pointerEvents = 'none';
  });
}

// Function to enable buttons within dynamic-checkout__content
function enableDynamicCheckoutButtons() {
  var dynamicCheckoutButtons = document.querySelectorAll('.dynamic-checkout__content button');
  dynamicCheckoutButtons.forEach(function (button) {
    button.disabled = false;
    button.style.pointerEvents = 'auto';
  });
}

// Function to handle checkbox change event
function handleCheckboxChange(event) {
  var isChecked = event.target.checked;
  var checkboxes = document.querySelectorAll('.terms-container input[type="checkbox"]');
  checkboxes.forEach(function (checkbox) {
    checkbox.checked = isChecked;
  });

  if (isChecked) {
    enableCheckoutButtons();
    enableDynamicCheckoutButtons();
  } else {
    disableCheckoutButtons();
    disableDynamicCheckoutButtons();
  }
}

// Add event listener to the checkboxes
var checkboxes = document.querySelectorAll('.terms-container input[type="checkbox"]');
checkboxes.forEach(function (checkbox) {
  checkbox.addEventListener('change', handleCheckboxChange);
});

// Call the initial checkbox check
handleCheckboxChange({ target: checkboxes[0] });

const SHIPPING_THRESHOLDS = {
  DKK: 40000,
};

window.__shippingLastPercent = (function () {
  try {
    const s = sessionStorage.getItem('shippingLastPercent');
    return s !== null ? Number(s) : 0;
  } catch {
    return 0;
  }
})();

function clampShipping(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

function formatShippingMoney(cents, currency) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format((cents || 0) / 100);
  } catch {
    return ((cents || 0) / 100).toFixed(2) + ' ' + (currency || '');
  }
}

function applyShippingI18n(wrapper) {
  if (!wrapper) return;

  const addEl = wrapper.querySelector('.cart-shipping__add');
  const remEl = wrapper.querySelector('.cart-shipping__remaining');
  const succEl = wrapper.querySelector('.cart-shipping__successText');
  const physEl = wrapper.querySelector('.physical-product-text');

  if (addEl) addEl.textContent = wrapper.dataset.add || '';
  if (remEl) remEl.textContent = wrapper.dataset.remaining || '';
  if (succEl) succEl.textContent = wrapper.dataset.success || '';
  if (physEl) physEl.textContent = wrapper.dataset.physicalNotice ? ' ' + wrapper.dataset.physicalNotice : '';
}

function calculateShippingProgress(currentCents, targetCents, currency) {
  const wrapper = document.querySelector('.cart-shipping__wrapper');
  if (!wrapper) return;

  applyShippingI18n(wrapper);

  const progressBar = wrapper.querySelector('.cart-shippingThreshold__progress');
  const progressOuter = wrapper.querySelector('.cart-shipping__numOuter');
  const successMsg = wrapper.querySelector('.cart-shipping__success');
  const progressNum = wrapper.querySelector('.cart-shipping__num');
  const bar = wrapper.querySelector('.cart-shippingThreshold__bar');

  const percent = targetCents > 0
    ? clampShipping(Math.round((100 * currentCents) / targetCents), 0, 100)
    : 100;

  const remaining = Math.max(targetCents - currentCents, 0);

  if (progressBar) {
    const hasInlineWidth = !!progressBar.style.width;

    if (!hasInlineWidth) {
      const prev = Number.isFinite(window.__shippingLastPercent) ? window.__shippingLastPercent : 0;
      const prevTransition = progressBar.style.transition;
      progressBar.style.transition = 'none';
      progressBar.style.width = prev + '%';
      progressBar.offsetWidth;
      progressBar.style.transition = prevTransition || 'width 0.25s ease';
      progressBar.style.width = percent + '%';
    } else {
      progressBar.style.width = percent + '%';
    }
  }

  if (bar) bar.setAttribute('aria-valuenow', String(percent));

  if (remaining <= 0) {
    if (successMsg) successMsg.style.display = 'block';
    if (progressOuter) progressOuter.style.display = 'none';
  } else {
    if (successMsg) successMsg.style.display = 'none';
    if (progressOuter) progressOuter.style.display = 'block';
    if (progressNum) progressNum.textContent = formatShippingMoney(remaining, currency);
  }

  const shipTotalsEl = document.querySelector('.shipping-totals .totals__subtotal-value');
  if (shipTotalsEl) {
    shipTotalsEl.textContent =
      remaining <= 0
        ? wrapper.dataset.shippingCostFree || 'Free'
        : wrapper.dataset.shippingCostCalc || shipTotalsEl.textContent;
  }

  window.__shippingLastPercent = percent;
  try {
    sessionStorage.setItem('shippingLastPercent', String(percent));
  } catch {}
}

window.updateFreeShippingBar = async function () {
  const wrapper = document.querySelector('.cart-shipping__wrapper');
  if (!wrapper) return;

  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    if (!cart || !cart.item_count) {
      wrapper.style.display = 'none';
      wrapper.removeAttribute('data-ready');
      return;
    }

    const liveCurrency =
      (cart && (cart.currency || cart.presentment_currency)) ||
      wrapper.dataset.currency ||
      window.Shopify.currency.active ||
      'DKK';

    const currency = String(liveCurrency || '').toUpperCase();

    if (currency !== 'DKK') {
      wrapper.style.display = 'none';
      wrapper.removeAttribute('data-ready');
      return;
    }

    const threshold = SHIPPING_THRESHOLDS[currency] || SHIPPING_THRESHOLDS.DKK;

    wrapper.style.display = 'block';
    calculateShippingProgress(cart.total_price, threshold, currency);
    wrapper.setAttribute('data-ready', 'true');
  } catch (e) {
    console.error('[Shipping Bar] Error updating bar', e);
  }
};

document.addEventListener('DOMContentLoaded', function () {
  if (window.updateFreeShippingBar) {
    window.updateFreeShippingBar();
  }
});